var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-flag")]),_vm._v(_vm._s(_vm.subsection_title))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }